import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { RootState } from '../redux/store';
import { axios } from '../services/axios';
import { authorize, getToken, redirectUri, responseType } from '../services/auth';
import { getRedirectUrl } from '../utils/storage';
import { toParams } from '../utils/oauth';
import { UserType } from '../types/user.type';
import { storeName } from '../redux/models/user.model';

const responseTypeLocationKeys = {
  code: 'search',
  token: 'hash',
};

const responseTypeDataKeys = {
  code: 'code',
  token: 'access_token',
};

type Props = { requiredAuth?: boolean };

const useAuth = (props?: Props): { user: UserType; isAuthenticated: boolean } => {
  const { requiredAuth = true } = props || {};
  const history = useHistory();

  const user = useSelector((state: RootState) => state[storeName].user);
  const dispatch = useDispatch()[storeName];

  const getUser = () => {
    dispatch
      .getUserDetailAsync()
      .then((userResult: any) => {
        if (!userResult && requiredAuth) {
          authorize();
        } else {
          const redirectUrl = getRedirectUrl();
          if (redirectUrl) {
            const url = new URL(redirectUrl);
            history.push(`${url.pathname}${url.search}`);
          }
        }
      })
      .catch((err: any) => {
        console.error('useAuth:', err);
        if (requiredAuth) {
          authorize();
        }
      });
  };

  useEffect(() => {
    if (!user) {
      if (window.location.href.indexOf(redirectUri) !== -1) {
        const locationKey = responseTypeLocationKeys[responseType];
        const search = window.location[locationKey];
        const params = toParams(search);
        const responseKey = responseTypeDataKeys[responseType];
        getToken({ code: params[responseKey], onSuccess: getUser });
        return;
      }
      axios.setToken();
      getUser();
    }
  }, [user]);
  return { user, isAuthenticated: !!user };
};

export default useAuth;
